import React from 'react';
import { Row, Col } from 'reactstrap';
import AnalyticsSection from '../components/analytics_section';
import OverviewCard from '../components/overview_card';
import BarChartCard from '../components/barchart_card';
import MetricSummaryRow from '../components/metric_summary';
import { formatNumber } from '../data';
import '../style.css';

const SkeletonBox = ({ width = '100%', height = '16px', style = {} }) => (
  <div
    className="skeleton-box"
    style={{ width, height, ...style }}
  />
);

const SubscriptionTab = ({ 
  subscriptionDateRange, 
  setSubscriptionDateRange, 
  activeSubscriptions,
  newSubscribersData, 
  totalRevenueData, 
  cancellationsData,
  isLoading = false,
}) => {
  const isContentPartner = localStorage.getItem('role_id') == 8;

  return (
    <>
      <AnalyticsSection 
        title="Quick Overview" 
        dateRange={subscriptionDateRange}
        onDateChange={setSubscriptionDateRange}
        reportLink="/new-analytics/subscriptions"
        isQuickOverview={true}
        hideReportLink={isContentPartner}
      >
        <Row>
          {!isContentPartner && (
            <Col md={4}>
              <OverviewCard
                title="New Subscribers"
                value={formatNumber(newSubscribersData.netValue)}
                percentageChange={newSubscribersData.percentageChange}
                formattedPercentageChange={newSubscribersData.formattedPercentageChange}
                link='/report/subscribed_users'
                showLink={true}
                isLoading={isLoading}
              />
            </Col>
          )}
          <Col md={isContentPartner ? 6 : 4} className={isContentPartner ? '' : 'border-column'}>
            <OverviewCard
              title="Total Revenue"
              value={`$${formatNumber(totalRevenueData.netValue)}`}
              percentageChange={totalRevenueData.percentageChange}
              formattedPercentageChange={totalRevenueData.formattedPercentageChange}
              link='/report/revenue_report'
              showLink={true}
              isLoading={isLoading}
            />
          </Col>
          {!isContentPartner && (
            <Col md={4}>
              <OverviewCard
                title="Cancellations"
                value={formatNumber(cancellationsData.netValue)}
                percentageChange={-cancellationsData.percentageChange}
                formattedPercentageChange={cancellationsData.formattedPercentageChange}
                link='/report/cancel_report'
                showLink={true}
                isLoading={isLoading}
              />
            </Col>
          )}
        </Row>
        {!isContentPartner && (
          <MetricSummaryRow
            metrics={[
              {
                label: "new subscribers",
                value: formatNumber(newSubscribersData.netValue),
                percentageChange: newSubscribersData.percentageChange,
                period: subscriptionDateRange[0].label
              },
              {
                label: "revenue",
                value: `$${formatNumber(totalRevenueData.netValue)}`,
                percentageChange: totalRevenueData.percentageChange,
                period: subscriptionDateRange[0].label
              },
              {
                label: "cancellations",
                value: formatNumber(cancellationsData.netValue),
                percentageChange: -cancellationsData.percentageChange,
                period: subscriptionDateRange[0].label
              }
            ]}
          />
        )}
      </AnalyticsSection>

      <AnalyticsSection 
        title="Subscription Overview" 
        dateRange={subscriptionDateRange}
        onDateChange={setSubscriptionDateRange}
        reportLink="/new-analytics/subscriptions"
        hideReportLink={isContentPartner}
      >
        <Row>
          {!isContentPartner && (
            <Col md={6} className="mb-3">
              <div className="active-subscriber-container">
                <h5 className="fs-3 mb-6">Active Subscriber Count</h5>
                <div className="active-subscriber-wrapper">
                  <div  className="active-subscriber-card">
                    <div className="active-subscriber-blob-top"></div>
                    <div className="active-subscriber-blob-bottom"></div>
                    <div className="active-subscriber-count">
                      {isLoading ? (
                        <SkeletonBox width="110px" height="42px" style={{ borderRadius: '8px' }} />
                      ) : (
                        formatNumber(activeSubscriptions) || "0"
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )}
          {!isContentPartner && (
            <Col md={6} className="mb-3">
              <BarChartCard
                title="New Subscribers"
                value={formatNumber(newSubscribersData.netValue)}
                percentageChange={newSubscribersData.percentageChange}
                formattedPercentageChange={newSubscribersData.formattedPercentageChange}
                xAxis={newSubscribersData.xAxis}
                yAxis={newSubscribersData.yAxis}
                dataName="Subscriptions"
                isLoading={isLoading}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col md={isContentPartner ? 12 : 6} className="mb-3">
            <BarChartCard
              title="Total Revenue"
              value={`$${formatNumber(totalRevenueData.netValue)}`}
              percentageChange={totalRevenueData.percentageChange}
              formattedPercentageChange={totalRevenueData.formattedPercentageChange}
              xAxis={totalRevenueData.xAxis}
              yAxis={totalRevenueData.yAxis}
              dataName="Revenue"
              isLoading={isLoading}
            />
          </Col>
          {!isContentPartner && (
            <Col md={6} className="mb-3">
              <BarChartCard
                title="Cancellations"
                value={formatNumber(cancellationsData.netValue)}
                percentageChange={-cancellationsData.percentageChange}
                formattedPercentageChange={cancellationsData.formattedPercentageChange}
                xAxis={cancellationsData.xAxis}
                yAxis={cancellationsData.yAxis}
                dataName="Cancellations"
                isLoading={isLoading}
              />
            </Col>
          )}
        </Row>
      </AnalyticsSection>
    </>
  );
};

export default SubscriptionTab;